import React from "react";
import { useTranslation } from "react-i18next";
import Doctor from "../Assets/doctor-group.png";
import SolutionStep from "./SolutionStep";
import "../Styles/About.css";

function About() {
  const { t, i18n } = useTranslation();

  return (
    <div className={`about-section ${i18n.language === "he" ? "rtl" : ""}`} id="about" dir={i18n.language === "he" ? "rtl" : "ltr"}>
      <div className="about-image-content">
        <img src={Doctor} alt={t("doctorAlt")} className="about-image1" />
      </div>

      <div className="about-text-content">
        <h3 className="about-title">
          <span>{t("aboutTitle")}</span>
        </h3>
        <p className="about-description">{t("aboutDescription")}</p>

        <h4 className="about-text-title">{t("solutionsTitle")}</h4>

        <SolutionStep
          title={t("personalizedConsultationTitle")}
          description={t("personalizedConsultationDescription")}
        />

        <SolutionStep
          title={t("createTreatmentPlanTitle")}
          description={t("createTreatmentPlanDescription")}
        />

        <SolutionStep
          title={t("achievePeaceOfMindTitle")}
          description={t("achievePeaceOfMindDescription")}
        />
      </div>
    </div>
  );
}

export default About;
